import { isPlatformServer } from '@angular/common';
import { Component, ElementRef, Inject, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { windowScreen } from 'src/app/services/utility.service';
import { environment } from 'src/environments/environment';
import { HowworksComponent } from '../how-it-works-browse-category-nav/howitworks.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'home-slider',
  templateUrl: './homepage-slider.component.html',
  styleUrls: ['./homepage-slider.component.scss'],
})
export class HomepageSliderComponent implements OnInit {
  public screen: string = 'mobile';
  activeSlide: number = 1;
  assetURL = environment.cloudFrontAssetURL;
  activeTab = 1;
  isShowVideo = false;
  @ViewChild("sliderVideo1") sliderVideo1: ElementRef;
  @ViewChild("sliderVideo2") sliderVideo2: ElementRef;
  @ViewChild("sliderVideo3") sliderVideo3: ElementRef;
  @ViewChild("sliderVideo4") sliderVideo4: ElementRef;
  @ViewChild("sliderVideo5") sliderVideo5: ElementRef;
  constructor(@Inject(PLATFORM_ID) private platformId, public ngbModel: NgbModal) {
    if (!isPlatformServer(this.platformId)) {
      window.addEventListener('resize', this.handleWindowResize);
    }
  }
  ngOnInit() {
    if (!isPlatformServer(this.platformId)) {
      this.handleWindowResize();
      this.startAnimation();
    }
  }
  ngAfterViewInit() {
    if (!isPlatformServer(this.platformId)) {
      setTimeout(() => {
        this.isShowVideo = true;
        if (this.sliderVideo1 != undefined) {
          const media = this.sliderVideo1.nativeElement;
          media.muted = true;
          media.play()
        }
      }, 10000);
    }
  }
  handleWindowResize = (): void => {
    this.screen = windowScreen();
  };

  startAnimation = () => {
    setInterval(() => {
      if (this.activeSlide === 4) this.activeSlide = 1;
      else this.activeSlide++;
    }, 1800);
  };

  changeActiveTab(activeTabId: number) {
    this.activeTab = activeTabId;
    setTimeout(() => {
      if (this.sliderVideo1 != undefined) {
        const media = this.sliderVideo1.nativeElement;
        media.muted = true;
        media.play()
      }
      if (this.sliderVideo2 != undefined) {
        const media = this.sliderVideo2.nativeElement;
        media.muted = true;
        media.play()
      }
      if (this.sliderVideo3 != undefined) {
        const media = this.sliderVideo3.nativeElement;
        media.muted = true;
        media.play()
      }
      if (this.sliderVideo4 != undefined) {
        const media = this.sliderVideo4.nativeElement;
        media.muted = true;
        media.play()
      }
      if (this.sliderVideo5 != undefined) {
        const media = this.sliderVideo5.nativeElement;
        media.muted = true;
        media.play()
      }
    }, 100);
  }
  HowWorks() {
    const modelRef = this.ngbModel.open(HowworksComponent, {
      size: 'lg',
      windowClass: 'modal-holder',
      centered: true
    });
  }
}
